import { routerReducer } from 'react-router-redux';
import { persistedUserReducer } from '../auth/auth';
import { persistReducer, persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { reducer as reduxFormReducer } from 'redux-form';
import { components } from '@peachjar/components';

// import {layout} from '../layout.duck';
import { reducer as onboardingDataReducer } from '../../Onboarding/Registration/onboarding/onboarding.duck';
import { setupSchoolReducer } from '../../Onboarding/Setup/school/setup-school.duck';
import { staffPasswordReducer } from '../../Onboarding/Setup/staff-password/setup-staff-password.duck';
import { staffSetupReducer } from '../../Onboarding/Setup/staff/setup-staff.duck';
import { organizationSetupReducer } from '../../Onboarding/Setup/organization/setup-organization.duck';
import { setupParentReducer } from '../../Onboarding/Setup/parent/setup-parent.duck';
import { errors } from '../errors/errors.duck';

const { Notifications } = components;
const { notificationsReducer } = Notifications;

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [],
  blacklist: ['user'],
};

const rootReducer = persistCombineReducers(persistConfig, {
  routing: routerReducer,
  form: reduxFormReducer, // mounted under "form"
  onboarding: onboardingDataReducer,
  user: persistedUserReducer,
  notifications: notificationsReducer,
  errors,
  setupSchool: setupSchoolReducer,
  setupStaffPassword: staffPasswordReducer,
  setupStaff: staffSetupReducer,
  organizationSetup: organizationSetupReducer,
  setupParent: setupParentReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// export default rootReducer;
export default persistedReducer;



// WEBPACK FOOTER //
// ./src/_app/reducers/rootReducer.js